var map = {
	"./10/article.json": 81,
	"./11/article.json": 82,
	"./12/article.json": 83,
	"./14/article.json": 84,
	"./15/article.json": 85,
	"./16/article.json": 86,
	"./18/article.json": 87,
	"./19/article.json": 88,
	"./2/article.json": 89,
	"./20/article.json": 90,
	"./21/article.json": 91,
	"./22/article.json": 92,
	"./3/article.json": 93,
	"./4/article.json": 94,
	"./5/article.json": 95,
	"./6/article.json": 96,
	"./7/article.json": 97,
	"./8/article.json": 98,
	"./9/article.json": 99
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 563;


//////////////////
// WEBPACK FOOTER
// ./pages/media ^\.\/.*\/article\.json$
// module id = 563
// module chunks = 0